import styled from 'styled-components'

export const TemplateWrapper = styled.div`
  /* modes for tokens (custom, word, sentence ...) */
  && .custom {
    border: none;
    margin: 0;
  }
`
